export default "__VITE_ASSET__CE51xKwN__"